import React    from 'react';
// import ReactDOM from 'react-dom';
import { history }  from '../routers/AppRouter'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import PicEventInfo from './PicEventInfo';
// import PicLists from './PicLists';
import PicPeople from './PicPeople';
import PicInvites from './PicInvites';
import PicListsPage from './PicListsPage';

// The MuiTheme allows me to define the primary and secondary colors.
const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: '#2980B7', /* this is the blue */
        },
        secondary: {
            main: '#7F8C8D'  /* this is the greyshade4 */
            // light:
            // dark:
        }
    }
});

// The lets you extend the theme with styles for specific components.
// The styles are injected by the "withStyles" Higher Order Component.
const styles = theme => ({
    root: {
        flexgrow: 1,
        marginTop: 20,
        // The width below expand MuiPaper 100% on small devices. For large devices
        // its width is lessened to allow for advertising on the right.
        [theme.breakpoints.down('xs')]: {
         marginTop: 1,   
         width: '100%'
        },
    },
    MuiTabs: {
        align: 'center',
        // overflowY: 'hidden',
    },
    MuiTab: {
        fontSize: 12,
        textAlign: 'center',
    }
 
});

class CenteredTabs extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            value: 0,       /* defaults to tab-index value of 0 */
         };
    }

    handleChange = (event, value) => {
        this.setState({ value });

        // translate numeric value to tab text value
        let tab = '';  
        if (value === 0)   {tab = 'event'};
        if (value === 1)   {tab = 'people'};
        if (value === 2)   {tab = 'lists'};
        if (value === 3)   {tab = 'invites'};

        history.push(`/eventmanage/${tab}`);
    };

    render() {
        // The tabs component requires a numerica value. Next few lines
        // translates the props text value to the numeric equivalent (as tab index)
        let props_tab_value = this.props.value;  
        if (props_tab_value === 'event')   {props_tab_value = 0};
        if (props_tab_value === 'people')  {props_tab_value = 1};
        if (props_tab_value === 'lists')   {props_tab_value = 2};
        if (props_tab_value === 'invites') {props_tab_value = 3};
    
        const { classes } = this.props;
        const value = props_tab_value || this.state.value;  /* if no props_tab_value, default to state.value */
    
        return (
          <MuiThemeProvider theme={theme}>
            <Paper className={classes.root}>
                <Tabs className={classes.MuiTabs}
                value={value}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                fullWidth={false}
                centered
                >
                <Tab className={classes.MuiTab} label="Event"/>
                <Tab className={classes.MuiTab} label="People" />
                <Tab className={classes.MuiTab} label="Lists" />
                <Tab className={classes.MuiTab} label="Invites" />
                </Tabs>
                {value === 0 && <PicEventInfo /> }
                {value === 1 && <PicPeople /> }
                {value === 2 && <PicListsPage /> }
                {value === 3 && <PicInvites /> }
            </Paper>
          </MuiThemeProvider>
        );
      }
}
    
CenteredTabs.propTypes = {
    classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
    return {
        auth:   state.auth,
        picapp: state.picapp
    };
};

export default withStyles(styles)(CenteredTabs);



// WEBPACK FOOTER //
// ./src/components/PicMuiTabs.js